<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
            :actions="actions"
            :selectionEnabled="true"
        ></dx-grid>
        <v-dialog persistent v-model="updateClassDialog" max-width="700">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Class ({{
                        clickedClass.teacherH
                            ? clickedClass.teacherH
                            : clickedClass.branch +
                              " - " +
                              clickedClass.section
                    }})</v-card-title
                >
                <v-layout row class="mb-0 ma-0 pa-0">
                    <div class="mt-3 mr-2">{{ clickedClass.teacherH }}</div>
                    <v-btn
                        v-if="clickedClass.teacherRecording"
                        @click="clickedClass.teacherRecording = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3 mt-3"
                        v-if="clickedClass.teacherRecording"
                        controls
                        :src="clickedClass.teacherRecording"
                        style="height: 25px;"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mx-2"
                        :loading="uploading1"
                        @click="pickFile('1')"
                        style="height: 28px;"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="files1"
                        accept=".mp3"
                        @change="onFilePicked($event, '1')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="mb-0 ma-0 pa-0">
                    <div class="mt-3 mr-2">{{ clickedClass.teacherH2 }}</div>
                    <v-btn
                        v-if="clickedClass.teacher2Recording"
                        @click="clickedClass.teacher2Recording = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3 mt-3"
                        style="height: 25px;"
                        v-if="clickedClass.teacher2Recording"
                        controls
                        :src="clickedClass.teacher2Recording"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mx-2"
                        :loading="uploading2"
                        style="height: 28px;"
                        @click="pickFile('2')"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="files2"
                        accept=".mp3"
                        @change="onFilePicked($event, '2')"
                    />
                </v-layout>
                <v-divider></v-divider>
                <v-checkbox
                    class="mb-3"
                    hide-details
                    label="Public"
                    color="success"
                    v-model="clickedClass.isPublic"
                ></v-checkbox>
                <v-menu
                    v-if="showDatePicker"
                    class="mt-0"
                    v-model="datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            hide-details
                            class="mr-3"
                            v-model="clickedClass.publicDate"
                            :value="clickedClass.publicDate"
                            label="Public Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="clickedClass.publicDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUpdateClassDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="settingsDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Class Settings</v-card-title
                >
                <v-checkbox
                    class="mb-3"
                    hide-details
                    label="Public"
                    color="success"
                    v-model="settings.isPublic"
                ></v-checkbox>
                <v-menu
                    class="mt-0"
                    v-model="settings.datePickerMenu"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            hide-details
                            class="mr-3"
                            v-model="settings.publicDate"
                            :value="settings.publicDate"
                            label="Public Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            clearable
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="settings.publicDate"
                    ></v-date-picker>
                </v-menu>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="settingsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveSettings()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Classes",

        actions: [],

        updateClassDialog: false,
        clickedClass: "",
        processing: false,
        uploading1: false,
        uploading2: false,
        datePickerMenu: false,
        showDatePicker: false,
        files: [],
        url: "",
        regID: "",

        settingsDialog: false,

        settings: {
            isPublic: false,
            datePickerMenu: false,
            publicDate: "",
        },

        columns: [
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Students",
                field: "count",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class Announcement",
                field: "classAnnouncement",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Hebrew",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Hebrew 2",
                field: "teacherH2",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Public",
                field: "isPublic",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Public Date",
                field: "publicDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Code",
                field: "teacher",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Code 2",
                field: "teacher2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Name",
                field: "teacherName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Name2",
                field: "teacherName2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher1 Recording",
                field: "teacherRecording",
                visible: false,
                template: "link-audio-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher2 Recording",
                field: "teacher2Recording",
                template: "link-audio-cell-template",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    mounted() {},
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Update Settings",
                action: this.openSettingsDialog,
                showOnSelection: true,
            });

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "classInfo?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = "classInfo?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onRowClicked(classInfo) {
            this.clickedClass = JSON.parse(JSON.stringify(classInfo));
            this.clickedClass.publicDate = this.clickedClass.publicDate
                ? toISOLocal(new Date(this.clickedClass.publicDate)).substr(
                      0,
                      10,
                  )
                : null;
            this.showDatePicker = true;
            this.updateClassDialog = true;
        },
        openSettingsDialog() {
            this.settingsDialog = true;
        },
        pickFile(line) {
            if (line == 1) {
                this.$refs.files1.click();
            } else {
                this.$refs.files2.click();
            }
        },
        async onFilePicked(e, line) {
            this["uploading" + line] = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();
                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?convertMp3=true",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                if (line == 1) {
                    this.clickedClass.teacherRecording = response.url;
                } else {
                    this.clickedClass.teacher2Recording = response.url;
                }

                this["uploading" + line] = false;

                if (line == 1) {
                    this.$refs.files1.value = "";
                } else {
                    this.$refs.files2.value = "";
                }
            } catch (e) {
                this["uploading" + line] = false;
            }
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post("api/classInfo/updateClass", {
                    branch: this.clickedClass.branch,
                    class: this.clickedClass.class,
                    section: this.clickedClass.section,
                    regID: this.clickedClass.regID,
                    isPublic: this.clickedClass.isPublic
                        ? this.clickedClass.isPublic
                        : null,
                    publicDate: this.clickedClass.publicDate,
                    teachers: [
                        {
                            teacherCode: this.clickedClass.teacher,
                            teacherNameRecording: this.clickedClass
                                .teacherRecording,
                        },
                        {
                            teacherCode: this.clickedClass.teacher2,
                            teacherNameRecording: this.clickedClass
                                .teacher2Recording,
                        },
                    ],
                });

                this.closeUpdateClassDialog();
                this.processing = false;
                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        closeUpdateClassDialog() {
            this.updateClassDialog = false;

            this.$refs.files1.value = "";
            this.$refs.files2.value = "";
        },
        async saveSettings() {
            try {
                this.processing = true;

                const selected = this.$refs.grid.getSelectedRowsData();

                await this.$http.post(
                    "api/classInfo/updateClasses",
                    selected.map((c) => {
                        return {
                            branch: c.branch,
                            class: c.class,
                            section: c.section,
                            regID: c.regID,
                            isPublic: this.settings.isPublic,
                            publicDate: this.settings.publicDate,
                        };
                    }),
                );

                this.processing = false;
                this.settingsDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
